export default __webpack_public_path__ + "static/media/board-img.2bfed06c.gif";